
<b-icon icon="chevron-down" class="animated-caret" :class="{expanded: expanded}" v-on="$listeners" />
